
import { AirplaneGallery } from '../models/airplane-gallery';

export const AIRPLANEGALLERY: AirplaneGallery[] =
    [
        {
            id: 1,
            title: 'I-BNET',
            subtitle: 'Cessna Citation VII Serie 650 7085',
            // tslint:disable-next-line:max-line-length
            //The F-35 is optimized to be a multirole fighter, with the ability to perform air-to-air, air-to-ground and intelligence, surveillance and reconnaissance (ISR) missions. While the F-22 is superior to the F-35 in air-to-air missions, the F-35s air-to-air capability is superior to all other fighters.
            description: '',
            images: [
                './assets/fleet/airplane_01/ext2.jpg',
                './assets/fleet/airplane_01/ext1.jpg',
                './assets/fleet/airplane_01/ext3.jpg', './assets/fleet/airplane_01/ext4.jpg',
                './assets/fleet/airplane_01/ext5.jpg', './assets/fleet/airplane_01/ext6.jpg',
                './assets/fleet/airplane_01/ext8.jpg',
                './assets/fleet/airplane_01/int1.jpg',
                './assets/fleet/airplane_01/int3.jpg', './assets/fleet/airplane_01/int4.jpg',
                './assets/fleet/airplane_01/int5.jpg', './assets/fleet/airplane_01/int6.jpg',
                './assets/fleet/airplane_01/int7.jpg', './assets/fleet/airplane_01/int8.jpg',
                './assets/fleet/airplane_01/int9.jpg', './assets/fleet/airplane_01/int10.jpg',
                './assets/fleet/airplane_01/int11.jpg', './assets/fleet/airplane_01/int12.jpg',
                './assets/fleet/airplane_01/int13.jpg', './assets/fleet/airplane_01/int14.jpg',
                './assets/fleet/airplane_01/int15.jpg'
            ]
        }

    ];
